import { Box, CircularProgress, Typography } from '@mui/material';
import { Button, IconLibrary } from '@act/storybook';
import { UserDto } from '@act/shared/data-transfer-objects';
import { Goal, GoalType } from 'stories/containers/GoalsTracking/types';
import { GoalCard } from './GoalCard';
import {
  getGoalDisplayData,
  SCROLLBAR_STYLES,
} from './CallsFullScreenContent.utils';
import { LoadingStatus } from 'redux/types/shared-types';
import { generateDatadogTrackingProps } from '@act/toolkit/environment/environment/user-monitoring';

interface GoalsPanelContentProps {
  selectedMember: UserDto | undefined;
  goals: Goal[];
  goalsLoadingStatus: LoadingStatus;
  onGoalClick: (goal: Goal) => void;
  onAddNeedClick: () => void;
}

export const GoalsPanelContent = ({
  selectedMember,
  goals,
  goalsLoadingStatus,
  onGoalClick,
  onAddNeedClick,
}: GoalsPanelContentProps) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '12px',
          flexDirection: 'row',
        }}
      >
        <Typography variant="titleLarge" alignSelf="flex-start">
          Goals for {selectedMember?.firstName || 'Member'}
        </Typography>
        <Button
          {...generateDatadogTrackingProps('add-new-need-from-call-button')}
          variant="text"
          sx={{ alignText: 'center' }}
          onClick={onAddNeedClick}
          startIcon={
            <IconLibrary iconName="Plus" color="secondary" weight="regular" />
          }
        >
          Add Need
        </Button>
        {goalsLoadingStatus === 'loading' && <CircularProgress size={24} />}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 3,
          flexDirection: 'column',
          gap: '12px',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingRight: '8px',
            gap: '16px',
            display: 'flex',
            flexDirection: 'column',
            ...SCROLLBAR_STYLES,
          }}
        >
          {goalsLoadingStatus === 'loading' ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '32px',
              }}
            >
              <CircularProgress size={24} />
            </Box>
          ) : (
            goals?.map(goal => {
              const { title, dueDate } = getGoalDisplayData(goal);

              return (
                <GoalCard
                  key={`${goal.goalType}-${goal.id}`}
                  id={goal.id.toString()}
                  goalType={goal.goalType as GoalType}
                  title={title}
                  dueDate={dueDate}
                  onClick={() => onGoalClick(goal)}
                />
              );
            })
          )}
        </Box>
      </Box>
    </>
  );
};
